'use client'

import type { ReactElement, ReactNode } from 'react'

import { useState } from 'react'

import { Tooltip } from '#components/tooltip'

import { hasDisabledReason } from './disabled-reason'

interface DisabledReasonTooltipProps {
  reason: ReactNode
  children: ReactElement
}

/**
 * Opens the reason on hover and focus. The trigger must stay focusable and
 * hoverable while disabled (`aria-disabled`, never the native attribute).
 * Always mounted, so a reason coming or going doesn't remount the trigger and
 * drop its focus; render it whenever the caller passes a reason prop at all.
 */
export function DisabledReasonTooltip({
  reason,
  children,
}: DisabledReasonTooltipProps): ReactElement {
  const [open, setOpen] = useState(false)
  // Clicking a disabled element shouldn't hide the reason it's asking for.
  return (
    <Tooltip
      content={reason}
      open={open && hasDisabledReason(reason)}
      onOpenChange={setOpen}
      closeOnClick={false}
    >
      {children}
    </Tooltip>
  )
}
